import styled from 'styled-components'

import { media } from 'components/presentational'

export const MessageContainer = styled.div`
  max-width: 210px;
  font-size: 12px;
  min-height: 16px;
  color: var(--static-black);
  display: flex;
  flex-direction: column;

  /**
    Если убрать то на window ломается, правильное определение высоты
    https://youtrack.mamba.ru/issue/M-3319
  */
  max-height: 40px;
  overflow: hidden;

  ${media.tablet`
    max-width: none;
    ${(props) => props.theme.paddingRight}: 20px;
  `};

  &:hover,
  &:focus {
    color: var(--static-black);
  }
`

export const IconWrapper = styled.span`
  flex-shrink: 0;
  display: inline-block;
  vertical-align: middle;
  ${(props) => props.theme.marginRight}: 3px;
`
